import { render, staticRenderFns } from "./HistoryAccordion.vue?vue&type=template&id=05cf4b78&scoped=true"
import script from "./HistoryAccordion.vue?vue&type=script&lang=js"
export * from "./HistoryAccordion.vue?vue&type=script&lang=js"
import style0 from "./HistoryAccordion.vue?vue&type=style&index=0&id=05cf4b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cf4b78",
  null
  
)

export default component.exports